export const EMPTY_STRING = "";
export const DEFAULT_TIMEOUT = 30000;
